// client/src/components/tenant/UserDetail.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  getTenantUser,
  updateTenantUser,
} from '../../services/tenantUsersApi';

export default function UserDetail() {
  const { tenant, userId } = useParams();
  const tenantNum = Number(tenant);
  const id = Number(userId);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: '',
    email: '',
    firstname: '',
    lastname: '',
    phone: '',
    active: 1,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getTenantUser(tenantNum, id);
        setForm({
          username: data.username || '',
          email: data.email || '',
          firstname: data.firstname || '',
          lastname: data.lastname || '',
          phone: data.phone || '',
          active: data.active ? 1 : 0,
        });
      } catch (e) {
        setErr(e.message || 'Failed to load user');
      } finally {
        setLoading(false);
      }
    })();
  }, [tenantNum, id]);

  const save = async () => {
    try {
      setSaving(true);
      await updateTenantUser(tenantNum, id, form);
      navigate(`/${tenant}/tenantUsers`);
    } catch (e) {
      setErr(e.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="container"><div className="text-muted mt-3">Loading…</div></div>;
  if (err) return <div className="container"><div className="alert alert-danger mt-3">{err}</div></div>;

  return (
    <div className="container" style={{ maxWidth: 600 }}>
      <h3 className="hdr hdr--primary hdr--lg">Edit User</h3>

      <div className="mb-3">
        <label className="form-label">Username</label>
        <input className="form-control" value={form.username}
               onChange={e => setForm({ ...form, username: e.target.value })}/>
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input className="form-control" type="email" value={form.email}
               onChange={e => setForm({ ...form, email: e.target.value })}/>
      </div>

      <div className="row">
        <div className="col-6 mb-3">
          <label className="form-label">First name</label>
          <input className="form-control" value={form.firstname}
                 onChange={e => setForm({ ...form, firstname: e.target.value })}/>
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Last name</label>
          <input className="form-control" value={form.lastname}
                 onChange={e => setForm({ ...form, lastname: e.target.value })}/>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Phone</label>
        <input className="form-control" value={form.phone}
               onChange={e => setForm({ ...form, phone: e.target.value })}/>
      </div>

      <div className="form-check form-switch mb-4">
        <input className="form-check-input" type="checkbox"
               checked={!!form.active}
               onChange={e => setForm({ ...form, active: e.target.checked ? 1 : 0 })}/>
        <label className="form-check-label">Active</label>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
}
